export default __webpack_public_path__ + "57bdc65876464bc6e45575af9a356184.svg";